import React, { useEffect, useMemo, useState } from 'react';
import { FormSection, Loader, PageContainer, PageHeader } from "../../../components";
import { Button, Grid } from "@mui/material";
import { OBJECT_REFERRAL_CREATE, OBJECT_REFERRAL_ROUTE, PRESCRIPTION, PRESCRIPTION_EDIT_ROUTE } from "../../../routes";
import { useHistory, useParams } from "react-router-dom";
import DashboardLayout from "../../../layouts/Dashboard";
import RemoveIcon from '@mui/icons-material/Remove';
import PlusOneIcon from '@mui/icons-material/PlusOne';
import { FormProvider } from "../../../components/hook-form";
import { useForm, useWatch } from "react-hook-form";
import RHFTextField from "../../../components/hook-form/RHFTextField";
import useReload from "../../../hooks/useReload";
import LoadingButton from "@mui/lab/LoadingButton";
import RHFDate from "../../../components/hook-form/RHFDate";
import AnObjectField from "../../../components/Relations/AnObjectField";
import FactorObjectFields from "../../../components/Relations/FactorObjectFields";
import { FilialDivisionSelect2, FilialSelect, PurposeOfSelectionsSelectFiltered } from "../../../components/Select/domainSelects";
import EmployeeField from "../../../components/Relations/DoctorField";
import { $s3host, anObjectReferralCRUD, anObjectsCRUD, entityCRUD, factorCRUD, postForDownloadFileS3, prescriptionCRUD, protocolCRUD } from "../../../http";
import { useSelector } from "react-redux";
import useLoader from "../../../hooks/useLoader";
import { RHFUploadSingleFile } from "../../../components/hook-form/RHFUpload";
import Typography from "@mui/material/Typography";
import RHFIndicator from "../../../components/hook-form/RHFIndicator";
import { yupResolver } from "@hookform/resolvers/yup";
import { prescriptionSchema } from "../../../models/schemas/prescriptionSchema";
import { Document, Page } from "react-pdf";
import { REQUEST_STATE_ID_CREATED, REQUEST_STATE_ID_DECLINED } from "../../../redux/constants/requestStateConstants";
import { asJSONSafe, renderControls, RequestStateChecker, State } from "../../../functions";
import { controlsKSEK } from "../../../sections/Header/KSESHeader";
import { useTranslation } from "react-i18next";
import RHFGovernment from "../../../components/hook-form/RHFGovernment";
import { ORGANIZATION_ID_NCE } from '../../../redux/constants/organizationConstants';
import useRoles from '../../../hooks/useRoles';
import RHFActField from '../../../components/hook-form/RHFActField';
import { normalizeIndicators } from '../../../functions/normalization';
import ResultsAndProtocolsSection from '../../../sections/ResultsAndProtocolsSection';
import useDialogs from '../../../components/Dialog/useDialogs';
import ProtocolDetails from '../../Protocol/Popups/ProtocolDetails';
import { addRange } from '../../../functions/linqSimulation';
import { filterSignedProtocols } from '../../../models/protocolStateIds';
import { formatDate } from '../../../functions/formatters';
import { requestStateIds } from '../../../models/requestStateIds';
import PrescriptionPdf from './PrescriptionPdf';

function PrescriptionCreate(props) {
    const { push } = useHistory();
    const authorizedEmployee = useSelector(state => state.employee.authorizedEmployee)

    const defaultValues = useMemo(() => ({
        targetDate: new Date(),
        createdAt: new Date(),
        number: '',
        acts: [],
        indicators: [],
        targetObjectId: '',
        targetObject: {},
        purposeId: null,
        purpose: null,
        factorId: null,
        factor: null,
        objectId: null,
        committeeObject: null,
        standards: [],
        createdBy: {},
        createdById: '',
        filialId: "",
        filialDivisionId: "",
    }), []);
    const { reload, reloadValue } = useReload();
    const { id } = useParams();
    const isEditing = useMemo(() => id, [id]);
    const [isCreated, setIsCreated] = useState(true)
    const [recreated, setRecreated] = useState(false);
    const [anObjectReferrals, setAnObjectReferrals] = useState([]);
    const [protocols, setProtocols] = useState([]);
    const { t } = useTranslation();

    const disabled = (!isCreated && isEditing)
    const [file, setFile] = useState(null)
    const [fileSee, setFileSee] = useState(false)
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const { employee, isCommittee, isInRoles, isAdministrator } = useRoles();
    const [pdfOpen, setPdfOpen] = useState(false);
    const [res, setRes] = useState({});

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const handleGenerateObjectReferral = async () => {
        const objectReferralData = {
            filialId: value.filialId,
            filialDivisionId: value.filialDivisionId,
            createdById: value.createdById,
            departmentId: value.departmentId,
            prescriptionId: value.id,
            indicators: value.indicators,
        }


        push({
            pathname: OBJECT_REFERRAL_CREATE,
            state: {data: objectReferralData}
        })
    }


    const methods = useForm({
        defaultValues,
        resolver: yupResolver(prescriptionSchema)
    });
    const {
        loading: fetchLoading,
        start: fetchStart,
        stop: fetchStop,
    } = useLoader(false);

    const {
        handleSubmit,
        setValue, watch,
        control,
        reset,
        formState: { isSubmitting },
    } = methods;

    const value = watch()

    const state = useMemo(
        () => new RequestStateChecker(value?.state?.code),
        [value?.state?.code]
    );
    const stateCode = state?.stateCode?.toLowerCase();

    const fetchAnObjectReferrals = React.useCallback(async (id) => {
        const {result} = await anObjectReferralCRUD.search({
            paging: {skip: 0},
            filter: {
                prescriptionId: {
                    operand1: id,
                    operator: 'equals'
                }
            }
        });
        setAnObjectReferrals(result);
    }, [])

    const fetchProtocols = async (prescriptionId, prescriptionProtocols) => {
        const result = [];
        for (let i = 0; i < prescriptionProtocols.length; i++) {
            const item = prescriptionProtocols[i].protocol;
            // const protocolId = item.protocolId;

            // const protocolsResponse = await protocolCRUD.search({
            //     filter: {
            //         id: {
            //             operand1: protocolId,
            //             operator: 'equals'
            //         }
            //     },
            //     paging: { skip: 0, take: 1 }
            // });
            // const protocols2 = protocolsResponse.result;

            result.push(item);
            //addRange(result, protocols2);
        }

        setProtocols(result);
    }

    useEffect(() => {
        (async function () {
            if (isEditing) {
                fetchStart()
                const res = await prescriptionCRUD.get(id);
                setRes(res);
                setIsCreated(res?.state?.code === REQUEST_STATE_ID_CREATED)
                setRecreated(res.recreated);
                fetchProtocols(res.id, res.protocols);
                // const { bucketName, key, objectName } = JSON.parse(res.acts[0].actPath)
                // try {
                //     const response = await postForDownloadFileS3({
                //         bucketName,
                //         key,
                //         objectName
                //         //}, `https://ekpo.nce.kz/s3/api/v1/file/download`)
                //     }, `${$s3host.defaults.baseURL}api/v1/file/download`)
                //     const file = new Blob([response.data], { type: 'application/pdf' });
                //     const fileURL = URL.createObjectURL(file);
                //     setFile(fileURL)
                // } catch (e) {
                //     console.error(e);
                // }
                // setFileSee(true)
                // const acts = res?.acts.map(el => ({ actId: el.actId, ...el?.act }))
                const prev = methods.getValues?.() || {};

                let indicators = asJSONSafe(res?.indicators) || [];
                const { purposeOfSelectionId: _psId, purposeOfSelection: _ps, ...resRest } = res;

                // Prescription GET often returns a shallow targetObject (id/name only). AnObjectField
                // needs nested relations (section, subSection, legal form, etc.) — same as on row pick from table.
                let targetObjectResolved = resRest?.targetObject ?? prev?.targetObject ?? {};
                if (resRest?.targetObjectId) {
                    try {
                        targetObjectResolved = await anObjectsCRUD.get(resRest.targetObjectId);
                    } catch (e) {
                        targetObjectResolved = resRest?.targetObject ?? prev?.targetObject ?? {};
                    }
                }

                let purposeResolved = res.purpose ?? null;
                const purposeIdResolved = res.purposeId ?? res.purpose?.id ?? res.purposeOfSelectionId ?? null;
                if (purposeIdResolved && !purposeResolved?.name) {
                    try {
                        purposeResolved = await entityCRUD("purposeOfSelection").get(purposeIdResolved);
                    } catch {
                        purposeResolved = res.purpose ?? null;
                    }
                }

                let factorResolved = res.factor ?? null;
                const factorIdResolved = res.factorId ?? res.factor?.id ?? null;
                if (factorIdResolved && !factorResolved?.name) {
                    try {
                        factorResolved = await factorCRUD.get(factorIdResolved);
                    } catch {
                        factorResolved = res.factor ?? null;
                    }
                }

                reset({
                    ...resRest,
                    purposeId: purposeIdResolved,
                    purpose: purposeResolved,
                    factorId: factorIdResolved,
                    factor: factorResolved,
                    objectId: res.objectId ?? res.object?.id ?? res.committeeObject?.id ?? null,
                    committeeObject: res.object ?? res.committeeObject ?? null,
                    indicators: normalizeIndicators(indicators),
                    standards: asJSONSafe(res?.standards),
                    targetObject: targetObjectResolved,
                    createdBy: authorizedEmployee,
                    createdById: authorizedEmployee.id
                });
                await fetchAnObjectReferrals(res?.id);
                fetchStop()
            }
        }())
    }, [reloadValue]);


    React.useEffect(() => {
        if (authorizedEmployee) {
            setValue('createdBy', authorizedEmployee)
            setValue('createdById', authorizedEmployee.id)
        }
    }, [authorizedEmployee, authorizedEmployee?.id])

    const onSubmit = async state => {
        if (!filialId) {
            alert('Пожалуйста, выберите филиал');
            return;
        }

        let acts = [];
        if (!isEditing) {
            for (let el of state.acts) {
                let formData = new FormData()
                formData.append("file", el)
                const size = el.size
                const { data: s3Path } = await $s3host.post("/api/v1/file/upload?userName=user1&path=prescription&size=" + size, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                })
                acts.push({ actPath: s3Path })
            }
        }
        if (isEditing) {
            const data = { ...state }
            delete data.acts;
            delete data.orderTypeId;
            delete data.orderType;
            delete data.purposeOfSelectionId;
            delete data.purposeOfSelection;
            delete data.purpose;
            delete data.factor;
            delete data.committeeObject;
            delete data.object;
            await prescriptionCRUD.edit({ ...data, id: +id, indicators: state.indicators, standards: state?.standards })
        } else {
            const {
                orderTypeId: _o1,
                orderType: _o2,
                purposeOfSelectionId: _p1,
                purposeOfSelection: _p2,
                purpose: _purpose,
                factor: _factor,
                committeeObject: _co,
                object: _obj,
                ...createPayload
            } = state;
            const { id } = await prescriptionCRUD.create({ ...createPayload, indicators: state.indicators, standards: state?.standards, acts })
            return push(PRESCRIPTION_EDIT_ROUTE(id));
        }

    }
    const targetObject = useWatch({
        control,
        name: "targetObject",
    });


    const purposeId = useWatch({
        control,
        name: "purposeId",
    });
    const purpose = useWatch({
        control,
        name: "purpose",
    });
    const factorId = useWatch({
        control,
        name: "factorId",
    });
    const factor = useWatch({
        control,
        name: "factor",
    });
    const objectId = useWatch({
        control,
        name: "objectId",
    });

    const createdBy = useWatch({
        control,
        name: "createdBy",
    });

    const filialId = useWatch({
        control,
        name: "filialId",
    });
    const filialDivisionId = useWatch({
        control,
        name: "filialDivisionId",
    });
    const trace = useWatch({
        control,
        name: "trace",
        defaultValue: []
    });
    const processingTrace = trace.find(_ => _.stateId == requestStateIds.processing);

    const {
        start: startSubmit,
        stop: stopSubmit,
    } = useLoader(false);

    const [editProtocolOpen, setEditProtocolOpen] = useState(false);
    const [editProtocol, setEditProtocol] = useState(null);

    const handleEditProtocolOpen = async (protocolId) => {
        await startSubmit();
        const protocol = await protocolCRUD.get(protocolId);
        await setEditProtocol(protocol);
        await setEditProtocolOpen(true);

        await stopSubmit();
    }

    const {alert, DIALOG} = useDialogs();

    return (
        <DashboardLayout>
            <DIALOG/>
            <PageHeader controls={renderControls(controlsKSEK(value, reload, push, prescriptionCRUD, null, handleGenerateObjectReferral, 'Prescription', isInRoles, isAdministrator, { protocols }), {
                state: stateCode,
                roles: [],
            })} heading={isEditing ? `Предписание #${value?.number || ""} ${stateCode === State.Processsing ? '(отправлено в НЦЭ)' :
                    stateCode ? `(${t(`dashboard.state.${stateCode}`)})` : ""
                }` : "Предписание: Создание"}
                additionalControls={[
                    <Button
                        variant={"text"}
                        onClick={() => setPdfOpen(true)}
                    >
                        Просмотр Pdf
                    </Button>
                ]}>

            </PageHeader>
            <PageContainer>
                <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                    {isEditing && <Grid container>                        
                        <Grid item xs={12}>
                            <div>Дата создания: {formatDate(value.createdAt)}</div>
                            {processingTrace && <div>Дата отправления в НЦЭ: {formatDate(processingTrace.changedAt)}</div>}
                        </Grid>
                    </Grid>}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            paddingBottom: "20px",
                        }}
                    >
                        <p>
                            Приложение 4 к правилам проведения санитарно-эпидемиологической
                            экспертизы
                        </p>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <p>Форма</p>
                    </div>
                    <h4 style={{ textAlign: "center", fontWeight: '700' }}>
                        Предписание о проведении санитарно-эпидемиологической экспертизы
                    </h4>
                    {protocols?.length ? <FormSection heading="Протоколы" mb={4}>
                        <ResultsAndProtocolsSection
                            prescription
                            onProtocolClick={async (_) => {
                                await handleEditProtocolOpen(_);
                            }}
                            protocols={isCommittee() ? filterSignedProtocols(protocols) : protocols}
                            resultsReloadValue={reloadValue}
                        />
                    </FormSection> : null}
                    {employee &&
                        <Grid container>
                            <FilialSelect
                                style={{ marginBottom: "5px" }}
                                label={"Филиал пользователя"}
                                fullWidth
                                disabled={true}
                                value={employee.filialId}
                            />
                            {employee.filialDivisionId && <FilialDivisionSelect2
                                style={{ marginBottom: "5px" }}
                                label={"Районное отделение пользователя"}
                                fullWidth
                                disabled={true}
                                value={employee.filialDivisionId}
                                filialId={employee.filialId === 1 ? null : employee.filialId}
                            />}
                        </Grid>
                    }
                    <Grid container spacing={1}>
                        {stateCode == 'declined' && <Grid item xs={12}>
                            <label>Комментарий: {value.comment}</label>
                        </Grid>}
                        <Grid item xs={6}>
                            <RHFTextField disabled={disabled} label="№" name="number" />
                        </Grid>
                        <Grid item xs={6}>
                            <RHFDate disabled={disabled} label="Дата" name="createdAt" />
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                            <p style={{ width: "50%" }}>Дата назначения</p>
                            <RHFDate disabled={disabled} style={{ width: "50%", marginLeft: "30px" }} label="Дата назначения"
                                name="targetDate" />
                        </Grid>
                        <Grid item xs={12} sx={{ marginBottom: '10px' }}>
                            <AnObjectField disabled={disabled}
                                label="Наименование проверяемого субъекта"
                                value={targetObject}
                                onChange={(obj) => {
                                    setValue('targetObject', obj)
                                    setValue('targetObjectId', obj.id)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                            <p style={{ width: "50%" }}>
                                Должностное лицо санитарно-эпидемиологической службы
                            </p>
                            <RHFTextField disabled={disabled} style={{ width: "50%", marginLeft: "30px" }} label="ФИО"
                                name="responsibleFullName" />
                        </Grid>
                        {/* <Grid item xs={12}>
                            <Grid item xs={12} style={{overflowX: "auto"}}>
                                <RHFActField disabled={disabled} label="Акты" reload={reload}>
                        </RHFActField>
                            </Grid>
                            {!isEditing ? <RHFUploadSingleFile name="acts"/> : fileSee ? <div className="document-pdf">
                                {file && <Document

                                    file={file}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                >
                                    <Page pageNumber={pageNumber}/>
                                </Document>}
                                <div className="document-pdf__buttons">
                                    <Button disabled={pageNumber === 1} onClick={() => setPageNumber(prev => prev - 1)}
                                            variant="outlined" startIcon={<RemoveIcon/>}>
                                        Предыдущая страница
                                    </Button>
                                    <Button disabled={pageNumber === numPages}
                                            onClick={() => setPageNumber(prev => prev + 1)} variant="contained"
                                            sx={{marginLeft: '10px'}} endIcon={<PlusOneIcon/>}>
                                        Следующая страница
                                    </Button>
                                </div>
                                <p>Страница {pageNumber} из {numPages}</p>
                            </div> : <Loader/>}
                        </Grid> */}
                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                            <p style={{ width: "50%" }}>Установил (указать характер складывающейся
                                санитарно-эпидемиологической ситуации на
                                территории, группе объектов, нарушения законодательства Республики Казахстан в области
                                санитарно-эпидемиологического благополучия населения)
                            </p>
                            <RHFTextField disabled={disabled} style={{ width: "50%", marginLeft: "30px" }} label="Характер ситуации"
                                name="establishedSituationDescription" />
                        </Grid>
                        <RHFActField disabled={disabled} label="Рассмотрев представленные документы" reload={reload}>
                            Рассмотрев представленные документы
                        </RHFActField>
                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                            <p style={{ width: "50%" }}>
                                Основание вынесения Предписания
                            </p>
                            <PurposeOfSelectionsSelectFiltered
                                disabled={disabled}
                                fullWidth
                                formStyle={{ width: "50%", marginLeft: "30px" }}
                                required={false}
                                value={purposeId}
                                onChange={(val, opt) => {
                                    setValue('purposeId', val);
                                    setValue('purpose', opt || null);
                                    setValue('factorId', null);
                                    setValue('factor', null);
                                    setValue('objectId', null);
                                    setValue('committeeObject', null);
                                }}
                            />
                        </Grid>
                        <FactorObjectFields
                            disabled={disabled}
                            purpose={purpose}
                            factor={factor}
                            factorId={factorId}
                            objectId={objectId}
                            setValue={setValue}
                        />
                        <Grid item xs={12}>
                            <EmployeeField
                                disabled
                                label={"Создал заявку"}
                                fullWidth
                                object={createdBy}
                                value={createdBy?.id}
                                onChange={(obj) => {
                                    setValue('createdBy', obj)
                                    setValue('createdById', obj.id)
                                }}
                            />
                        </Grid>
                        <h6 style={{ fontWeight: "bold" }}>Постановил</h6>
                        <Grid item xs={12}>
                            <FilialSelect
                                disabled={disabled}
                                label={"Филиал"}
                                organizationId={ORGANIZATION_ID_NCE}
                                fullWidth
                                value={filialId}
                                onChange={(val) => {
                                    setValue('filialId', val)
                                    setValue('filialDivisionId', Number(val) !== Number(filialId)
                                        ? null
                                        : filialDivisionId)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FilialDivisionSelect2
                                disabled={disabled}
                                label={"Наименование отделения"}
                                organizationId={ORGANIZATION_ID_NCE}
                                fullWidth
                                value={filialDivisionId}
                                filialId={filialId === 1 ? null : filialId}
                                onChange={(nextFilialDivisionId, filialDivision) => {
                                    setValue('filialDivisionId', nextFilialDivisionId)
                                    setValue('filialId',
                                        filialDivision != null &&
                                        Number(filialDivision.filialId) !== Number(filialId)
                                            ? filialDivision.filialId
                                            : filialId)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                            <p style={{ width: "50%" }}>Документ санитарно-эпидемиологического нормирования (на
                                соответствие, которого проводится исследование (ГОСТ)
                            </p>
                            <RHFGovernment disabled={disabled} />
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                            <RHFIndicator disabled={disabled} />
                        </Grid>
                        <Grid item xs={12}>
                                <Typography gutterBottom variant={'h5'}>Заявки по ГЗ:</Typography>
                                <table>
                                    {anObjectReferrals.map(_ => <tr>
                                        <td onClick={() => {
                                            push(OBJECT_REFERRAL_ROUTE(_.id))
                                        }}>{_.number}</td>
                                    </tr>)}
                                </table>
                        </Grid>
                    </Grid>
                    <LoadingButton disabled={disabled} loading={isSubmitting} type="submit" variant="contained"
                        sx={{ mt: 3, mb: 2, alignSelf: 'flex-end' }}>
                        {isEditing ? 'Сохранить' : 'Добавить'}
                    </LoadingButton>
                </FormProvider>
                {protocols?.length ? <ProtocolDetails action={'details'} title={t("protocolList.detailsText")} reload={reload} open={editProtocolOpen} setOpen={setEditProtocolOpen}
                    protocol={editProtocol} /> : null}
                {pdfOpen && <PrescriptionPdf title={"Просмотр PDF"} open={pdfOpen} onClose={() => setPdfOpen(false)} data={res}/>}
            </PageContainer>
        </DashboardLayout>
    );
}

export default PrescriptionCreate;
